import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { WorkTimeTemplate } from '../types/workTimeTemplate';
import { workTimeTemplateService } from '../services/workTimeTemplateService';

interface WorkTimeTemplateState {
  // 상태
  templates: WorkTimeTemplate[];
  loading: boolean;
  error: string | null;
  
  // Actions
  fetchTemplates: (userId: string) => Promise<void>;
  getTemplateById: (templateId: string) => WorkTimeTemplate | null;
  subscribeTemplates: (userId: string) => () => void;
  
  // 상태 관리
  setTemplates: (templates: WorkTimeTemplate[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearTemplates: () => void;
}

export const useWorkTimeTemplateStore = create<WorkTimeTemplateState>()(
  devtools(
    subscribeWithSelector((set, get) => ({
      // 초기 상태
      templates: [],
      loading: false,
      error: null,
      
      // 템플릿 목록 가져오기
      fetchTemplates: async (userId: string) => {
        set({ loading: true, error: null });
        try {
          const templates = await workTimeTemplateService.getAllTemplates(userId);
          set({ templates, loading: false });
        } catch (error: any) {
          console.error('❌ workTimeTemplateStore: 템플릿 목록 가져오기 실패', error);
          set({ error: error.message || '템플릿을 가져오는데 실패했습니다.', loading: false });
        }
      },
      
      // 템플릿 ID로 조회
      getTemplateById: (templateId: string) => {
        const state = get();
        return state.templates.find(t => t.id === templateId) || null;
      },
      
      // 실시간 템플릿 구독
      subscribeTemplates: (userId: string) => {
        return workTimeTemplateService.subscribeTemplates(userId, (templates) => {
          set({ templates });
        });
      },
      
      // 상태 관리
      setTemplates: (templates: WorkTimeTemplate[]) => {
        set({ templates });
      },
      
      setLoading: (loading: boolean) => {
        set({ loading });
      },
      
      setError: (error: string | null) => {
        set({ error });
      },
      
      clearTemplates: () => {
        set({ templates: [], error: null });
      },
    })),
    { name: 'WorkTimeTemplateStore' }
  )
);


